import ContactPerson from './contactperson'

export default ContactPerson
